import { BaseClient } from '@/api'
import request from '@/utils/request'

export class DriverRechargeClient extends BaseClient {
  constructor(
  ) {
    super('driver-recharges')
  }

  async revoke(id: number): Promise<any> {
    return request({
      url: `/${this.path}/${id}`,
      method: 'put',
      data: { status: 'revoked' }
    })
  }

  async agree(id: number): Promise<any> {
    return request({
      url: `/${this.path}/${id}`,
      method: 'put',
      data: { status: 'agreed' }
    })
  }

  async refuse(id: number): Promise<any> {
    return request({
      url: `/${this.path}/${id}`,
      method: 'put',
      data: { status: 'refused' }
    })
  }
}
